// extracted by mini-css-extract-plugin
export default {"root":"CollectionsLayout_root__OjC-4"};